import type { CommandDeckPersonalizationState, CommandDeckPreviewBundle } from '../contracts/types'
import { buildToolCards } from '../config/toolMatrix'
import { NOTICES_CONTROLLED_ACCESS, NOTICES_VISITOR } from '../fixtures/activityNotices'

/** Map resolver output to the existing Command Deck preview bundle shape (read-only). */
export function mapPersonalizationToPreviewBundle(
  state: CommandDeckPersonalizationState
): CommandDeckPreviewBundle {
  const tools = buildToolCards(state.userAccess.accessState)
  const notices =
    !state.hold.unlocked && state.hold.posture !== 'pathway'
      ? NOTICES_VISITOR
      : NOTICES_CONTROLLED_ACCESS

  return {
    access: state.userAccess,
    accessProfileId: state.accessProfileId,
    tools,
    progress: state.missionContext.progress,
    bestNextMove: state.missionContext.bestNextMove,
    notices,
    personalization: state,
  }
}
